module.exports = ".fleets-screen > .fleet-placeholder-desktop > img,\n.fleets-screen > .fleet-placeholder-mobile > img {\n  width: 100%; }\n\n@media only screen and (max-width: 767px) {\n  .fleets-screen > .fleet-placeholder-desktop > img {\n    display: none !important; } }\n\n@media only screen and (min-width: 768px) {\n  .fleets-screen > .fleet-placeholder-mobile > img {\n    display: none !important; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/fleets/fleets.scss
// module id = ./src/app/components/fleets/fleets.scss
// module chunks = main